import {
  CommunicationsIcon,
  CSNotesIcon,
  MedicationRequestIcon,
  PatientIcon,
  TaskIcon
} from '@/components/ui/icons/TimelineIcons'
import { colors } from '@/theme'
import type { TimelineEventCategory, TimelineEventSource } from '@/types/timeline'
import AssignmentTurnedInOutlined from '@mui/icons-material/AssignmentTurnedInOutlined'
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined'
import type { SvgIconProps } from '@mui/material'

export interface CategoryStyle {
  chipBg: string
  chipColor: string
  chipBorder?: string
  iconBg: string
  iconColor: string
  Icon: React.ComponentType<SvgIconProps>
}

export const CATEGORY_CONFIG: Record<TimelineEventCategory, CategoryStyle> = {
  Patient: {
    chipBg: colors.brand.primaryLight,
    chipColor: colors.brand.primary,
    iconBg: colors.brand.primaryLight,
    iconColor: colors.brand.primary,
    Icon: PatientIcon
  },
  Order: {
    chipBg: '#EFF6FF',
    chipColor: '#2563EB',
    iconBg: '#DBEAFE',
    iconColor: '#2563EB',
    Icon: LocalShippingOutlined
  },
  'Medication Requests': {
    chipBg: '#FAF5FF',
    chipColor: '#7C3AED',
    iconBg: '#FAF5FF',
    iconColor: '#7C3AED',
    Icon: MedicationRequestIcon
  },
  'CS notes': {
    chipBg: '#FFFFFF',
    chipColor: colors.brand.primary,
    chipBorder: colors.brand.primary,
    iconBg: '#FFFFFF',
    iconColor: colors.brand.primary,
    Icon: CSNotesIcon
  },
  Tasks: {
    chipBg: '#FEF6F3',
    chipColor: '#EA580C',
    iconBg: '#FBDECE',
    iconColor: '#EA580C',
    Icon: TaskIcon
  },
  Communications: {
    chipBg: '#FDF1FC',
    chipColor: '#DB29CE',
    iconBg: '#F8D4F5',
    iconColor: '#DB29CE',
    Icon: CommunicationsIcon
  },
  Investigations: {
    chipBg: colors.brand.primaryLight,
    chipColor: colors.brand.primary,
    iconBg: colors.brand.primary,
    iconColor: '#FFFFFF',
    Icon: AssignmentTurnedInOutlined
  }
}

export const ALL_CATEGORIES: TimelineEventCategory[] = [
  'Patient',
  'Order',
  'CS notes',
  'Medication Requests',
  'Investigations',
  'Tasks',
  'Communications'
]
export type TimelineCategory = (typeof ALL_CATEGORIES)[number]

export const ALL_SOURCES: TimelineEventSource[] = ['Manual', 'System']
